import InvoiceLine from "./invoice-line";

export default class Invoice{
    soCode : string;
    invoiceNo: string;
    soDate : Date;
    sumMoney : number;
    sumQty : number;
    numOfPackage:number;
    items : Array<InvoiceLine>;
    customer : CustomerOrderModel = new CustomerOrderModel();
    infoClient : InfoClientInvoice = new InfoClientInvoice();
    infoForm : InfoFormInvoice = new InfoFormInvoice;
    infoWarehouse : InfoWarehouseInvoice = new InfoWarehouseInvoice;
    receiver : ReceiverModel = new ReceiverModel();
    tpl : TplModel = new TplModel();
}

export class CustomerOrderModel{
    customerName : string;
    customerPhone : string;
    customerTax : string;
    customerAddress : string;
}

export class ReceiverModel{
    shippingName : string;
    shippingPhone : string;
    shippingAddress : string;
}

export class InfoClientInvoice{
    clientName : string;
    clientAddress : string;
    clientTax : string;
}

export class TplModel{
    code : string;
    shortName : string;
    name : string;
    contactName : string;
    contactPhone : string;
    fullAddress: string;
}

export class InfoFormInvoice{
    modelNumber : string;
    symbolNumer : string;
    formNumber : string;
    titleForm : string;
    contactNumber : string;
    contact : string;
    contactNote : string;
    exportAtWarehouse : string;
    importAtWarehouse : string;
    transitMethod : string;
}

export class InfoWarehouseInvoice{
    warehouseName : string;
    warehouseAddress : string;
}